import './HistoryInvoice.css';
import { Link, useLocation } from 'react-router-dom'

import { BasicLayout } from './Layouts/basicLayout'
import { FilterForm } from '../pages/DetalleFactura/Components/HistoryInvoice/FilterForm';
import { TableHistory } from '../pages/DetalleFactura/Components/HistoryInvoice/TableHistory';

import ModalsControl from '../pages/DetalleFactura/Components/ModalsControl';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveHistorialFactura, setResetHistorial } from '../actions/historial/historial.actions';
import { setActiveModuleDoc } from '../actions/documentos/documentos.actions';
import { getFechaHora } from '../actions/general.actions';
import { historialFilterChangeForm } from '../actions/historial/historialFilter.actions';
import { State } from '../reducers';

export const HistoryInvoice = () => {
  const {fecha_actual} = useSelector((state: State) => state.general); 

  const location = useLocation();
  const dispatch = useDispatch();

  const [lastReload, setLastReload] = useState<boolean|null>(null);
  const [showTable, setShowTable] = useState<boolean>(false);

  useEffect(() => {
    if (location.search) {
      const queryParams = new URLSearchParams(location.search);
      const reload = queryParams.get('reload');
      setLastReload(true);
      setShowTable(true);
    } else {
      checkReload();
    }
  }, [location.search]);

  const checkReload = () => {
    setTimeout(() => {
      setLastReload((currentReloadValue) => {
        if (!currentReloadValue) {
          dispatch(setActiveHistorialFactura(null));
          dispatch(setActiveModuleDoc({title: '', idDoc: ''}));
          dispatch(setResetHistorial());
          dispatch(historialFilterChangeForm({fechaFinal: fecha_actual?.FechaInput, fechaInicial: fecha_actual?.FechaInput}));
          setShowTable(true);
        }
        return currentReloadValue;
      });
    }, 500);
  }

  useEffect(() => {
    dispatch(getFechaHora());
  }, []);

  return (
    <BasicLayout>
      <ModalsControl />
      <div className='w-100'>
        <div className='header-link'>
          <Link to={'/home'} className='link'>
            <button className='back-button w-inline-block'></button>
          </Link>
          <h3 className='h3-titles xl'>Historial de documentos</h3>
        </div>
        <hr />
        <FilterForm />
        {showTable && 
          (
            <TableHistory />
          )
        }
      </div>
    </BasicLayout>
  )
}
